import { useGlobalStore, GlobalStore } from "@/store"
import { Notification } from "@/types/types"
import { useLocalStorage } from "usehooks-ts"

export function useNotifications() {
  const notificationsQueue = useGlobalStore((store) => store.notificationsQueue)
  const [ackedNotificationIds, setAckedNotificationIds] = useLocalStorage<string[]>(
    "_sf_ackedNotifications",
    [],
  )

  const update = useGlobalStore((store) => store.update)

  function addNotifications(notifications: Notification[]) {
    const existingNotifications = notificationsQueue || []
    const unacknowledgedNotifications = notifications.filter(
      (n) => !ackedNotificationIds.includes(n.id),
    )

    // Create a map of existing notifications by ID
    const existingMap = new Map(existingNotifications.map((n) => [n.id, n]))

    // Add new notifications, overwriting existing ones with the same ID
    unacknowledgedNotifications.forEach((n) => {
      existingMap.set(n.id, n)
    })

    // Convert back to array
    const updatedNotificationsQueue = Array.from(existingMap.values())

    update({ notificationsQueue: updatedNotificationsQueue })
  }

  function removeNotification(notificationId: Notification["id"]) {
    const existingNotifications = notificationsQueue || []
    const filteredNotifications = existingNotifications.filter((n) => n.id !== notificationId)

    update({ notificationsQueue: filteredNotifications })
    setAckedNotificationIds([...ackedNotificationIds, notificationId])
  }

  function clearAllNotifications() {
    update({ notificationsQueue: [] })
  }

  return [
    notificationsQueue || [],
    addNotifications,
    removeNotification,
    clearAllNotifications,
  ] as const
}
